$(document).ready(function(){
	//Step 1
	$('.select-list').children('input').each(function(){
		if($(this).hasClass('is-invalid-input')){
			$(this).siblings('.select-list-button')
			.children('input')
			.addClass('is-invalid-input');
			$(this).next('svg').addClass('is-invalid-input');
		}
	});

	$(document).on('keyup', '.security-password', Foundation.util.throttle(function(event) {
		var password = $(this).val();
		var securityBar = $(this).siblings('.security-bar-container').find('.security-bar');
		updateSecurityBar(securityBar, checkPassStrength(password));
	}, 500));
	
	// Init au chargement
	updateSecurityBar(
		$('.security-password').siblings('.security-bar-container').find('.security-bar'),
		checkPassStrength($('.security-password').val())
	);
	
	$(document).on('keyup', 'input', function(event){
		$('input[name="'+$(this).attr('name')+'"], input[name="'+$(this).attr('name')+'"] + label')
			.removeClass('is-invalid-input')
			.siblings('span.alert-notice').remove();
	});
	
	$(document).on('change', '.select-list', function() {
		$(this).siblings('span.alert-notice').remove();
	});

	//Step 2 Sans checkbox

	//bouton activé au scroll
	$('.cgu').scroll(function () {
		let margin = 5;
		if ($(this).scrollTop() + $(this).innerHeight() + margin >= $(this)[0].scrollHeight) {
			$('#button-modal').removeAttr('disabled');
		}
	});

	//Step 2 Avec checkbox

	/*$(document).on('click', 'div.select-list', function(){
		$('div[name="'+$(this).attr('name')+'"]')
			.removeClass('is-invalid-input')
			.siblings('span.alert-notice').remove();	
	}); 

	var checked = false;
	var scrolled = false;

	/*$('.cgu').scroll(function(){
		var docScroll = $(this);
		if(docScroll.innerHeight() + docScroll.scrollTop() === docScroll[0].scrollHeight){
			scrolled = true;
		}else{
			scrolled = false;
		}
	});*/	
	
	/*$(document).on('click', '.process-step2-form', function(){
		var checkBox = $('input[name="cgu"]');
		if(checkBox.is(':checked')){
			checked = true;
		}else{
			checked = false;
		}
	});*/
	
	/*$(document).on('submit', '.process-step2-form', function(event){
		event.preventDefault();
		if(checked === true){
			if(scrolled === true){
				event.currentTarget.submit();
			} else {
				//CHECKED true SCROLLED false
				App.Component.Alert.showPopup(__('subscription.errors.scrolled_bottom'), 'alert', __('subscription.title'));
			}
		} else {
			if(scrolled === true){
				//CHECKED false SCROLLED true
				App.Component.Alert.showPopup(__('subscription.errors.checked_bottom'), 'alert', __('subscription.title'));
			} else {
				//CHECKED false SCROLLED false (BOTH false)
				App.Component.Alert.showPopup(__('subscription.errors.read_bottom'), 'alert', __('subscription.title'));
			}
		}
	});*/	

});
